import { z } from "zod";
export const createContractTemplateSchema = z
    .object({
    name: z.string().min(1).max(200),
    ejs_content: z.string().min(1),
    is_default: z.boolean(),
    deposit_percentage: z.number().int().min(0).max(100).default(30),
    deposit_percentage_short: z.number().int().min(0).max(100).default(50),
    short_threshold_days: z.number().int().min(0).max(365).default(30),
    full_payment_threshold_days: z.number().int().min(0).max(365).default(14),
    balance_due_days_before: z.number().int().min(0).max(365).default(14),
    cancellation_grace_period_days: z.number().int().min(0).max(365).default(90),
    deposit_refund_days: z.number().int().min(0).max(365).default(7),
})
    .refine((data) => data.full_payment_threshold_days <= data.short_threshold_days, {
    path: ["full_payment_threshold_days"],
    message: "full_payment_threshold_days must be less than or equal to short_threshold_days",
})
    .refine((data) => data.deposit_percentage <= data.deposit_percentage_short, {
    path: ["deposit_percentage_short"],
    message: "deposit_percentage_short must be greater than or equal to deposit_percentage",
});
export const updateContractTemplateSchema = z
    .object({
    name: z.string().min(1).max(200).optional(),
    ejs_content: z.string().min(1).optional(),
    is_default: z.boolean().optional(),
    deposit_percentage: z.number().int().min(0).max(100).optional(),
    deposit_percentage_short: z.number().int().min(0).max(100).optional(),
    short_threshold_days: z.number().int().min(0).max(365).optional(),
    full_payment_threshold_days: z.number().int().min(0).max(365).optional(),
    balance_due_days_before: z.number().int().min(0).max(365).optional(),
    cancellation_grace_period_days: z.number().int().min(0).max(365).optional(),
    deposit_refund_days: z.number().int().min(0).max(365).optional(),
})
    .refine((data) => data.full_payment_threshold_days === undefined ||
    data.short_threshold_days === undefined ||
    data.full_payment_threshold_days <= data.short_threshold_days, { path: ["full_payment_threshold_days"], message: "full_payment_threshold_days must be less than or equal to short_threshold_days" })
    .refine((data) => data.deposit_percentage === undefined ||
    data.deposit_percentage_short === undefined ||
    data.deposit_percentage <= data.deposit_percentage_short, { path: ["deposit_percentage_short"], message: "deposit_percentage_short must be greater than or equal to deposit_percentage" });
